import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white rounded-4 shadow p-4 mb-5"
}
const _hoisted_2 = { class: "fw-bold mb-5" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-center mb-5"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4 border-bottom" }
const _hoisted_8 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_9 = { class: "row mx-0 px-0 col-lg-4 align-items-center" }
const _hoisted_10 = { class: "w-max-content col-2 col-form-label" }
const _hoisted_11 = { class: "col-10" }
const _hoisted_12 = { class: "row mx-0 px-0 col-lg-4 align-items-center" }
const _hoisted_13 = { class: "w-max-content col-2 col-form-label" }
const _hoisted_14 = { class: "col-10" }
const _hoisted_15 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4 border-bottom" }
const _hoisted_16 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_17 = { class: "row mx-0 px-0 col-lg-4 align-items-center" }
const _hoisted_18 = { class: "w-max-content col-2 col-form-label" }
const _hoisted_19 = { class: "col-10" }
const _hoisted_20 = { class: "row mx-0 px-0 col-lg-4 align-items-center" }
const _hoisted_21 = { class: "w-max-content col-2 col-form-label" }
const _hoisted_22 = { class: "col-10" }
const _hoisted_23 = { class: "pb-4 gx-3 mb-4 border-bottom d-flex align-items-center" }
const _hoisted_24 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_25 = { class: "px-3" }
const _hoisted_26 = { class: "pb-4 gx-3 mb-4 border-bottom d-flex align-items-center" }
const _hoisted_27 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_28 = { class: "px-3 text-break" }
const _hoisted_29 = { class: "pb-4 gx-3 mb-4 border-bottom d-flex align-items-center" }
const _hoisted_30 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_31 = { class: "px-3" }
const _hoisted_32 = { class: "pb-4 gx-3 mb-4 border-bottom d-flex align-items-center" }
const _hoisted_33 = { class: "w-max-content col-lg-3 col-4 col-form-label" }
const _hoisted_34 = { class: "px-3 d-flex align-items-center" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "ms-3 mt-1" }
const _hoisted_37 = { class: "pb-4 gx-3 mb-4 border-bottom d-flex" }
const _hoisted_38 = { class: "d-flex col-3 align-items-center justify-content-between" }
const _hoisted_39 = { class: "w-max-content col-form-label" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode()
const _hoisted_41 = { class: "px-3 col-lg-8 py-2" }
const _hoisted_42 = ["for"]
const _hoisted_43 = ["id", "value", "disabled"]
const _hoisted_44 = { class: "row mx-0 px-0 d-flex justify-content-center flex-lg-row flex-column-reverse" }
const _hoisted_45 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_46 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4" }

import { computed, onMounted, ref, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import { translate } from '@/languages/i18n'
import { USER_MANAGEMENT_STORE } from '@/store/constants'

import Status from '@/components/status/index.vue'
import Button from '@/components/button/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import ConfirmModalEdit from './components/ConfirmEdit.vue'
import CompletedEdit from './components/CompletedEdit.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()

const dataInfor = computed(() => store.getters[USER_MANAGEMENT_STORE.GETTERS.ADMINNISTRATOR_INFOR]?.administratorInfor)
const dataError = computed(() => store.getters[USER_MANAGEMENT_STORE.GETTERS.ADMINNISTRATOR_INFOR]?.error)
const loading = computed(() => store.getters[USER_MANAGEMENT_STORE.GETTERS.ADMINNISTRATOR_INFOR]?.loading)

const afterMount = ref<boolean>(false)
const PAGE_LIST_PATH = `/community/communities/${router.currentRoute.value.params?.id}/managers?management_no=asc`

onMounted(() => {
  store.dispatch(USER_MANAGEMENT_STORE.ACTIONS.SET_ADMINNISTRATOR_INFOR, {
    id: router.currentRoute.value.params?.id,
    management_no: router.currentRoute.value.params?.management_no,
  })
  afterMount.value = true
})

const serverError = ref<boolean>(false)

const formData = ref({
  available: false,
  is_contact_admin: false,
})

const isAdmin = ref<boolean>(false)

watchEffect(() => {
  formData.value = {
    available: dataInfor.value.available,
    is_contact_admin: dataInfor.value.is_contact_admin,
  }
  isAdmin.value = dataInfor.value.is_contact_admin
})

const rules = computed(() => {
  return {
    available: { required },
    is_contact_admin: {},
  }
})

const v$ = useVuelidate(rules, formData)

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()

  if (v$.value.$invalid) {
    return
  }
}

const messageModalCompleted = (status: boolean): void => {
  serverError.value = status
}

const radioList = [
  {
    title: translate('OE30available'),
    status: true,
  },
  {
    title: translate('OE10pause'),
    status: false,
  },
]

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${router.currentRoute.value.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('settings'),
    to: '',
    active: false,
  },
  {
    content: translate('CC10listOfAdmin'),
    to: PAGE_LIST_PATH,
    active: false,
  },
  {
    content: translate('CC40title'),
    to: '',
    active: true,
  },
]

watchEffect(() => {
  if (afterMount.value) {
    if (dataError.value) {
      const url = new URL(PAGE_LIST_PATH, window.location.origin)
      const queryObj = Object.fromEntries(url.searchParams.entries())
      router.replace({
        path: url.pathname,
        query: queryObj,
      })
    }
  }
})
const isContactAdmin = (is_contact_admin) => {
  isAdmin.value = is_contact_admin
}

const backToPageList = () => {
  router.push(PAGE_LIST_PATH)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    (!_unref(dataInfor)?.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('CC40title')), 1),
          (_unref(loading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
            : _createCommentVNode("", true),
          (!_unref(loading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(translate)('nameKanji')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(translate)('surName')), 1),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(dataInfor)?.family_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(translate)('name')), 1),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(dataInfor)?.given_name), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(translate)('nameKatakana')), 1),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)('surNameKatakana')), 1),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(dataInfor)?.family_name_kana), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(translate)('lastNameKatakana')), 1),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(dataInfor)?.given_name_kana), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(translate)('SB20belong')), 1),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(dataInfor)?.department_name), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(translate)('email')), 1),
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(dataInfor)?.email), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(translate)('dateOfBirth')), 1),
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(dataInfor)?.birthday), 1)
                ]),
                _createElementVNode("form", {
                  onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(translate)('CC10contractor')), 1),
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input cursor-pointer mt-0",
                        type: "checkbox",
                        disabled: isAdmin.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).is_contact_admin.$model) = $event)),
                        id: "flexCheckDefault"
                      }, null, 8, _hoisted_35), [
                        [_vModelCheckbox, _unref(v$).is_contact_admin.$model]
                      ]),
                      _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(translate)('CC40setContractor')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("label", _hoisted_39, _toDisplayString(_unref(translate)('OE30usageSettings')), 1),
                      _hoisted_40,
                      _createVNode(Status)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", {
                        class: _normalizeClass(['d-flex align-items-center', _unref(v$).is_contact_admin.$error ? 'is-invalid' : ''])
                      }, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(radioList, (item) => {
                          return _createElementVNode("div", {
                            class: "col-lg-3 form-check me-4",
                            key: item.title
                          }, [
                            _createElementVNode("label", {
                              class: "form-check-label fs-7 text-nowrap cursor-pointer",
                              for: `showInTimeline1${item.title}`
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                class: "form-check-input cursor-pointer",
                                id: `showInTimeline1${item.title}`,
                                value: item.status,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).available.$model) = $event)),
                                disabled: isAdmin.value || _unref(dataInfor)?.current_user
                              }, null, 8, _hoisted_43), [
                                [_vModelRadio, _unref(v$).available.$model]
                              ]),
                              _createTextVNode(" " + _toDisplayString(item.title), 1)
                            ], 8, _hoisted_42)
                          ])
                        }), 64))
                      ], 2),
                      _createVNode(InputErrorMessage, {
                        title: _unref(translate)('OE30usageSettings'),
                        validator: _unref(v$).available.$errors[0]?.$validator
                      }, null, 8, ["title", "validator"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(Button, {
                        title: _unref(translate)('back'),
                        type: 'secondary',
                        onClick: backToPageList
                      }, null, 8, ["title"])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(Button, {
                        title: _unref(translate)('confirm'),
                        type: 'secondary',
                        onClick: onSubmit,
                        dataBsToggle: !_unref(v$).$invalid ? 'modal' : '',
                        dataBsTarget: '#modalConfirmEdit'
                      }, null, 8, ["title", "dataBsToggle"])
                    ])
                  ])
                ], 32)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(ConfirmModalEdit, {
      data: formData.value,
      messageModalCompleted: messageModalCompleted,
      onIsContactAdmin: isContactAdmin
    }, null, 8, ["data"]),
    _createVNode(CompletedEdit, { serverError: serverError.value }, null, 8, ["serverError"])
  ], 64))
}
}

})